module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-scan-f0931b0e51d8a5649336a8882284270f.svg";